import React from 'react';
import faker from 'faker';
import Chart from '../../../../components/organisms/chart';
import useRenderChartRoute from './hooks';

interface Props {
    currentRoute: {value: number, label: string} | null;
}

function RenderChartRoute(props: Props) {
  const { currentRoute } = props;
  const {
    currentView, setCurrentView, routeSales, isLoading, isDataExists,
  } = useRenderChartRoute(currentRoute);
  const { CustomTopContent, Default } = Chart.Overview;
  return (
    <Default
      title="Weekly Sales"
      topContent={[
        CustomTopContent('Today', faker.datatype.number({ min: -10, max: 10 }), routeSales?.total?.today),
        CustomTopContent('This Week', faker.datatype.number({ min: -10, max: 10 }), routeSales?.total?.week),
        CustomTopContent('This Month', faker.datatype.number({ min: -10, max: 10 }), routeSales?.total?.oneMonth),
        CustomTopContent('3 Months', faker.datatype.number({ min: -10, max: 10 }), routeSales?.total?.threeMonth),
        CustomTopContent('6 Months', faker.datatype.number({ min: -10, max: 10 }), routeSales?.total?.sixMonth),
        CustomTopContent('1 Year', faker.datatype.number({ min: -10, max: 10 }), routeSales?.total?.year),
      ]}
      items={[
        { label: 'Snack', bgColor: 'rgb(225, 143, 80)', amount: routeSales?.data?.snack ?? [] },
        { label: 'Soda', bgColor: 'rgb(117, 192, 219)', amount: routeSales?.data?.soda ?? [] },
      ]}
      currentView={currentView}
      setCurrentView={setCurrentView}
      labels={routeSales?.data?.label ?? []}
      isData={isDataExists}
      isLoading={isLoading}
    />
  );
}

export default React.memo(RenderChartRoute);
